import useSwr from 'swr'
import { type Course } from '@mc/api'

export const useCourseBySlug = (slug?: string | null) => {
  const { data, error, isLoading } = useSwr<Course>(
    slug ? `/jsonapi/v1/courses/${slug}?` : null,
  )

  return {
    courseBySlug: data,
    error,
    isLoading,
  }
}
